/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useMemo } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

interface ShowSerialNumberProps {
  selectedRow: any;
}

const ShowSerialNumber = ({ selectedRow }: ShowSerialNumberProps) => {
  const { t } = useTranslation();
  const {
    control,
    reset,
    formState: { errors }
  } = useForm();

  const [searchSerialNumber, setSearchSerialNumber] = useState<string>('');

  useEffect(() => {
    if (
      selectedRow?.serial_number &&
      Array.isArray(selectedRow?.serial_number)
    ) {
      const nameObj: any = {};
      selectedRow?.serial_number?.forEach((value: string, index: number) => {
        nameObj[`name_${index}`] = value;
      });
      reset(nameObj);
    }
  }, [selectedRow, reset]);

  // Filtered serial numbers based on search
  const filteredSerials = useMemo(() => {
    if (!selectedRow?.serial_number) return [];

    return selectedRow.serial_number
      .map((sn: string, index: number) => ({ sn, index }))
      .filter(({ sn }: any) =>
        sn.toLowerCase().includes(searchSerialNumber.trim().toLowerCase())
      );
  }, [searchSerialNumber, selectedRow?.serial_number]);

  return (
    <Form
      noValidate
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <div className="form-icon-container mb-3">
        <Form.Floating>
          <Form.Control
            type="text"
            placeholder={t('search')}
            onFocus={e => e.target.select()}
            onChange={e => setSearchSerialNumber(e.target.value)}
            className="form-icon-input"
          />
          <label
            htmlFor="floatingInputCustom"
            className="form-icon-label text-700"
          >
            {t('search')}
          </label>
        </Form.Floating>
        <FontAwesomeIcon icon={faSearch} className="text-900 fs-9 form-icon" />
      </div>
      {filteredSerials.map(({ index }: any) => (
        <Row key={index} className="mb-3">
          <Col>
            <Controller
              disabled={true}
              name={`name_${index}`}
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Form.Floating className="md-4">
                  <Form.Control
                    {...field}
                    type="text"
                    placeholder={`${t('serial_number')} ${index}`}
                    onFocus={e => e.target.select()}
                    isInvalid={!!errors[`name_${index}`]}
                  />
                  <label htmlFor={`name_${index}`}>
                    {t('serial_number')} ( {index + 1} )
                  </label>
                  {errors[`name_${index}`] && (
                    <Form.Control.Feedback type="invalid">
                      {t('required_field')}
                    </Form.Control.Feedback>
                  )}
                </Form.Floating>
              )}
            />
          </Col>
        </Row>
      ))}
    </Form>
  );
};

export default ShowSerialNumber;
